import { pathRedirect } from '@/utils/auth'

import Dashboard from '@/containers/BusinessCharges/Dashboard'

export default {
  path: 'businessCharges',
  redirect: pathRedirect,
  children: [
    { path: 'dashboard', component: Dashboard }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/businessCharges.js